// extracted by mini-css-extract-plugin
export default {"link":"Home_link__Evt2P","cardsContainer":"Home_cardsContainer__VIctw"};